"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("customerCommunications").controller("CustomerCommunicationCtrl", CustomerCommunicationCtrl);

  function CustomerCommunicationCtrl($rootScope, $scope, $controller, $timeout, FormlyService, CustomListsService, CustomerCommunicationsService, params) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "CustomerCommunicationCtrl";

    vm.log = debug("pages:customerCommunication");

    vm.createFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var values, keywordsList;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([CustomListsService.getSelectArray("keywords")] //0
              );

            case 2:
              values = _context.sent;
              keywordsList = values[0].map(function (item) {
                return { value: item.value, name: "#" + item.name };
              });
              _context.next = 6;
              return localforage.getItem("oneAtATime");

            case 6:
              vm.oneAtATime = _context.sent;
              _context.t0 = {
                class: "col-xs-12 col-sm-2 col-md-2",
                boxes: []
              };
              _context.t1 = FormlyService;
              _context.next = 11;
              return CustomListsService.getSelectArray("typeCustomerCommunication");

            case 11:
              _context.t2 = _context.sent;
              _context.t3 = {
                className: "col-xs-12 col-sm-12 col-md-12"
              };
              _context.t4 = _context.t1.list.call(_context.t1, "communicationType", "Quoi", _context.t2, true, _context.t3);
              _context.t5 = FormlyService;
              _context.next = 17;
              return CustomListsService.getSelectArray("typeCommunicationWay");

            case 17:
              _context.t6 = _context.sent;
              _context.t7 = {
                className: "col-xs-12 col-sm-12 col-md-12"
              };
              _context.t8 = _context.t5.list.call(_context.t5, "communicationWay", "Moyen de diffusion", _context.t6, true, _context.t7);
              _context.t9 = FormlyService.date("communicationDate", "Date de la communication", true, {
                className: "col-xs-12 col-sm-12 col-md-12"
              });
              _context.t10 = {
                type: "nya-bs-select-multiple",
                key: "keywords",
                id: "keywords",
                className: "col-xs-12 col-sm-12",
                templateOptions: {
                  label: "Mots-clés",
                  placeholder: "Sélectionner un ou plusieurs mots-clés",
                  options: keywordsList,
                  multiple: "multiple"
                }
              };
              _context.t11 = FormlyService.textArea("note", "Commentaires", "...", false, {
                className: "col-xs-12 col-sm-12 col-md-12"
              });
              _context.t12 = [_context.t4, _context.t8, _context.t9, _context.t10, _context.t11];
              _context.t13 = {
                mainTitle: "Informations",
                fields: _context.t12
              };
              _context.t14 = [_context.t13];
              _context.t15 = {
                class: "col-xs-12 col-sm-4 col-md-4",
                boxes: _context.t14
              };
              _context.t16 = {
                class: "col-xs-12 col-sm-4 col-md-4",
                boxes: [{
                  mainTitle: "Documents liés",
                  fields: [FormlyService.doc("docs", "Documents liés", "customerCommunication", false, {
                    className: "col-xs-12 col-sm-12 col-md-12"
                  }, "", false)]
                }]
              };
              _context.t17 = [_context.t0, _context.t15, _context.t16];
              _context.t18 = {
                columns: _context.t17
              };
              vm.rows = [_context.t18];


              $timeout(function () {}, 0);

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.check = function () {
      var save = true;

      if (!vm.model.communicationType) {
        save = false;
        Notiflix.Notify.failure("Veuillez sélectionner un type de communication");
      }
      if (!vm.model.communicationWay) {
        save = false;
        Notiflix.Notify.failure("Veuillez sélectionner un moyen de diffusion");
      }
      if (!vm.model.communicationDate) {
        save = false;
        Notiflix.Notify.failure("Veuillez sélectionner une date de communication");
      }

      if (save) {
        vm.save();
      }
    };

    vm.ready = function () {
      vm.createFields();
    };

    $controller("CreateBaseController", {
      vm: vm,
      $scope: $scope,
      service: CustomerCommunicationsService,
      listPage: "customerCommunications",
      nameModel: "une communication",
      params: params
    });
  }
})();